import FloorPlanNormalizedDataCore from './FloorPlanNormalizedDataCore';

const IncludedFloorPlansNormalizedData = (
  floorPlanNids,
  deserializedData,
  drupalIncluded,
) => {

  const floorPlans = deserializedData?.map( ( deserializedFloorPlan ) => {
    const floorPlan = FloorPlanNormalizedDataCore( deserializedFloorPlan, drupalIncluded );
    const rawFloorPlan = floorPlanNids.find( ( match ) => match.id === floorPlan.uuid );
    floorPlan.drupalNid = rawFloorPlan?.meta?.drupal_internal__target_id;
    return floorPlan;
  } );
  return floorPlans
};

export default IncludedFloorPlansNormalizedData;
